export interface LaborLinePathResult {
  pathDs: string[]
  isolatedPoints: Array<{ x: number; y: number }>
}

/** Build SVG path segments from plot values; null creates gaps in the line. */
export function buildLaborLinePaths(
  values: Array<number | null>,
  xStep: number,
  yScale: (value: number) => number,
): LaborLinePathResult {
  const pathDs: string[] = []
  const isolatedPoints: Array<{ x: number; y: number }> = []

  let segmentStart: number | null = null
  let segmentCommands: string[] = []

  const flushSegment = (endIndex: number) => {
    if (segmentStart == null || segmentCommands.length === 0) return
    if (segmentCommands.length === 1) {
      const value = values[endIndex]
      if (value != null) {
        isolatedPoints.push({
          x: endIndex * xStep,
          y: yScale(value),
        })
      }
    } else {
      pathDs.push(segmentCommands.join(' '))
    }
    segmentStart = null
    segmentCommands = []
  }

  for (let index = 0; index < values.length; index++) {
    const value = values[index]
    if (value == null) {
      if (segmentStart != null) {
        flushSegment(index - 1)
      }
      continue
    }

    const x = index * xStep
    const y = yScale(value)
    if (segmentStart == null) {
      segmentStart = index
      segmentCommands = [`M ${x} ${y}`]
    } else {
      segmentCommands.push(`L ${x} ${y}`)
    }
  }

  if (segmentStart != null) {
    flushSegment(values.length - 1)
  }

  return { pathDs, isolatedPoints }
}
